import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { api, type User } from "./api";

const families = [
  { slug: "personal", label: "Personal", ready: true },
  { slug: "business", label: "Business", ready: true },
  { slug: "isa", label: "ISA", ready: false },
  { slug: "charity", label: "Charity", ready: false },
];

export default function Shell({
  user,
  onLogout,
  children,
}: {
  user: User;
  onLogout: () => void;
  children: ReactNode;
}) {
  async function handleLogout() {
    await api.logout();
    onLogout();
  }

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 border-r bg-white px-4 py-6 flex flex-col">
        <div className="flex items-baseline gap-2 mb-8">
          <span className="text-xl font-semibold">PDF Factory</span>
        </div>
        <nav className="space-y-1 text-sm">
          <div className="text-xs uppercase tracking-wider text-neutral-500 mb-2">
            Guides
          </div>
          {families.map((f) => (
            <NavLink
              key={f.slug}
              to={`/?family=${f.slug}`}
              className={({ isActive }) =>
                `flex items-center justify-between rounded px-3 py-2 ${
                  isActive ? "bg-neutral-100" : "hover:bg-neutral-50"
                } ${!f.ready ? "text-neutral-400" : ""}`
              }
            >
              <span>{f.label}</span>
              {!f.ready && (
                <span className="text-[10px] uppercase">soon</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-6 border-t text-sm">
          <div className="font-medium">{user.name}</div>
          <div className="text-xs text-neutral-500 mb-3">{user.email}</div>
          <button
            onClick={handleLogout}
            className="text-sm text-neutral-600 hover:text-neutral-900"
          >
            Log out
          </button>
        </div>
      </aside>
      <main className="flex-1">{children}</main>
    </div>
  );
}
